module.exports = __webpack_public_path__ + "static/media/big-neon-checkout-userflow.f712cb3c.jpg";